<template>
  <div class="warp" style="padding:0 15px;background-color:#fff;height:1140px">
    <div class="node" style="padding:10px 0px 0px 0px;overflow:hidden;">
      <a-row>
        <a-col>
          <a-icon type="left" style="float:left;margin-top:4px;" />
        </a-col>
        <a-col>
          <div style="text-align:center;">
            新闻与公告
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="content" style="margin-top: 15px;">
      <a-input placeholder="输入你想要搜索的内容" style="background-color:#f5f5f5;">
        <a-icon slot="prefix" type="search" />
      </a-input>
    </div>
    <div style="margin-top:30px;">
      <span style="font-size:18px;line-height:16px;color:#333333;font-weight:bolder;">新闻</span>
      <span style="font-size:14px;margin-left:23px;line-height:16px;color:#999999">公告</span>
    </div>
    <div style="border-bottom:1px solid #d2d2d2;padding-bottom:15px;">
      <div style="font-size:16px;line-height:24px;color:#333333;margin-top:28px;">
        我从不认输,直到陪孩子读书我从不轻易认输,直到陪孩子读...
      </div>
      <div style="font-size:12px;line-height:16px;color:#999999;margin-top:15px;">
        2020-10-20
      </div>
    </div>
    <div style="border-bottom:1px solid #d2d2d2;padding-bottom:15px;margin-top:22px;">
      <div style="font-size:16px;line-height:24px;color:#333333;margin-top:28px;">
        我从不认输,直到陪孩子读书我从不轻易认输,直到陪孩子读...
      </div>
      <div style="font-size:12px;line-height:16px;color:#999999;margin-top:15px;">
        2020-10-20
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'News',
  description: '新闻与公告',
  // 初始化变量
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="stylus">
    .warp .content input {
        background-color:#f5f5f5;
    }
</style>
